import DynamicTable from '../../../../components/DynamicTable/DynamicTable';
import styles from './UpcomingInvoices.module.css';

import { useState } from 'react';
import CheckboxAndData from '../../../../components/CheckboxAndData/CheckboxAndData';

function UpcomingInvoices() {
  const [tableData, setTableData] = useState([]); // you can populate this dynamically later

  const tableHeadings = [
    { title: <CheckboxAndData />, accessor: 'checkbox' },
    { title: 'Fee Plan Name', accessor: 'feePlanName' },
    { title: 'Generated Date', accessor: 'generatedDate' },
    { title: 'Due Date', accessor: 'dueDate' },
    { title: 'Total', accessor: 'total' },
    { title: 'Pending', accessor: 'pending' },
  ];
  return (
    <div className={styles.UpcomingInvoices}>
      <DynamicTable headings={tableHeadings} columnData={tableData} />
    </div>
  );
}

export default UpcomingInvoices;
